import PropTypes from 'prop-types';

import React from 'react';

import { List } from 'immutable';

function Errors({ errorMessages }) {
  return errorMessages && errorMessages.size ? (
    <div>
      {
        errorMessages.map(errorMessage => (
          <div key={errorMessage}>
            <span role="img" aria-label="Взрыв">💥</span>
            &nbsp;
            {errorMessage}
          </div>
        ))
      }
    </div>
  ) : null;
}

Errors.propTypes = {
  errorMessages: PropTypes.instanceOf(List),
};

export default Errors;
